import { render, staticRenderFns } from "./FunnelSettingsWrapper.vue?vue&type=template&id=2fad6251&lang=pug&"
import script from "./FunnelSettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./FunnelSettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports